"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapCartItemsFromCartResponse = void 0;
function mapCartItemsFromCartResponse(cart) {
    return cart.items.map((item) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return ({
            id: item.sku,
            quantity: item.quantity,
            price: String((_a = item.prices) === null || _a === void 0 ? void 0 : _a.price),
            brand: item.brand,
            name: item.name,
            description: item.name,
            discountPrice: ((_b = item.prices) === null || _b === void 0 ? void 0 : _b.discountPrice) < ((_c = item.prices) === null || _c === void 0 ? void 0 : _c.price)
                ? String(((_d = item.prices) === null || _d === void 0 ? void 0 : _d.price) - ((_e = item.prices) === null || _e === void 0 ? void 0 : _e.discountPrice))
                : String((_f = item.prices) === null || _f === void 0 ? void 0 : _f.price),
            cycle: String(cart.cycle),
            image: item.images[0],
            tags: item.tags,
            businessUnit: cart.businessUnit,
            category: item.category,
            hasPromptDelivery: Boolean((_g = item.quantityDetails) === null || _g === void 0 ? void 0 : _g.resellerStock),
            hasPromptDeliveryStock: Boolean((_h = item.quantityDetails) === null || _h === void 0 ? void 0 : _h.distributionCenter),
            organizationName: item.organization,
        });
    });
}
exports.mapCartItemsFromCartResponse = mapCartItemsFromCartResponse;
